module.exports = __webpack_public_path__ + "img/bxtk.a69e212a.png";